import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Title for Tax & Billing Settings',
    defaultMessage: 'Tax & Billing Settings',
    id: 'IfGugR',
  },
  button: {
    description: 'button to add tax identifier in panel',
    defaultMessage: 'Add {taxIdName}',
    id: 'DAAbNx',
  },
  banner: {
    description: 'banner message to clarify tax identifier panel',
    defaultMessage: 'Please enter a valid {taxIdName} Number',
    id: 'x4XIXc',
  },
  optionalTag: {
    description: 'tag to indicate that tax identifier is optional',
    defaultMessage: '(Optional)',
    id: '7m13ZK',
  },
});
